export function AffiliationRoutes() {
  return <></>;
}
